import type {
  DatabaseFilterClause,
  DatabaseSortClause,
  DatabaseSortField,
} from '@couplespace/core/databases';

import type { DatabaseQueryInput } from './types';

export type { DatabaseFilterClause, DatabaseSortClause, DatabaseSortField };

/** Must match API Zod max on `POST /rpc/databases/:id/query` (see databases.ts). */
export const DATABASE_VIEW_ROW_CAP = 100;

export function buildDatabaseQueryInput(params: {
  search: string;
  filters: DatabaseFilterClause[];
  sorts: DatabaseSortClause[];
  groupBy: DatabaseSortField | null;
  columnAggregates?: Record<string, string>;
}): DatabaseQueryInput {
  const filter: DatabaseQueryInput['filter'] = [];

  for (const clause of params.filters) {
    filter.push({
      propertyId: clause.propertyId,
      operator: clause.operator,
      value: clause.value,
    });
  }

  const trimmedSearch = params.search.trim();

  const footers =
    params.columnAggregates && Object.keys(params.columnAggregates).length > 0
      ? Object.entries(params.columnAggregates).map(([propertyId, fn]) => ({
          propertyId,
          function: fn,
        }))
      : undefined;

  return {
    search: trimmedSearch || undefined,
    filter: filter.length > 0 ? filter : undefined,
    sort:
      params.sorts.length > 0
        ? params.sorts
        : [{ field: 'position', direction: 'asc' }],
    groupBy: params.groupBy ?? undefined,
    limit: DATABASE_VIEW_ROW_CAP,
    includeProperties: true,
    footers,
  };
}

export function formatGroupKey(
  key: string | null,
  groupBy: DatabaseSortField,
  columns: { id: string; name: string }[],
): string {
  if (key === null || key === '') {
    return 'Empty';
  }
  if (groupBy === 'title') {
    return key;
  }
  if (groupBy === 'position') {
    return key;
  }
  const col = columns.find((c) => c.id === groupBy.propertyId);
  return col ? `${col.name}: ${key}` : key;
}
